import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  monthlyIncome: "100000",
  creditPay: "10000",
  carPay: "5000",
  studentPay: '5000',
  dtiErrors: null,
  remainingIncome: 0,
  totalMonthlyDebt: 0,
  dtiRatio: '',
};

const dtiSlice = createSlice({
  name: "dtiCalculator",
  initialState: initialState,

  reducers: {
    setMonthlyIoncome: (state, action) => {
      state.monthlyIncome = action.payload;
    },
    setCreditPay: (state, action) => {
      state.creditPay = action.payload;
    },
    setCarPay: (state, action) => {
      state.carPay = action.payload;
    },
    setStudentPay: (state, action) => {
      state.studentPay = action.payload;
    },
    setDebetRatio: (state, action) => {
      state.dtiRatio = action.payload;
    },
    setTotalMonthlyDebt: (state, action) => {
      state.totalMonthlyDebt = action.payload;
    },
    setRemainingIncome: (state, action) => {
      state.remainingIncome = action.payload;
    },
    resetDtiData: (state) => {
      return initialState;
    },
  }
});

export const { setActiveCalculater } = dtiSlice.actions;
export const { setMonthlyIoncome, setCreditPay, setCarPay, resetDtiData, setStudentPay, setDebetRatio, setTotalMonthlyDebt, setRemainingIncome } = dtiSlice.actions;
export default dtiSlice.reducer;